"use client";

import React, { useState } from "react";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable";
import { formatDate, formatMoney } from "../utils/utils";

const Cobranza = () => {
    const [fecha, setFecha] = useState("");
    const [resultados, setResultados] = useState([]);

    const buscarCobranza = async () => {
        if (!fecha) return;
        const [anio, mes] = fecha.split("-");
        try {
            const params = { fecha };
            const response = await axiosInstance.get("/acuerdo-mutuo/cobranza", { params });
            setResultados(response.data.data);
        } catch (error) {
            console.error("Error al buscar cobranza:", error);
        }
    };

    const columns = [
        { title: "Paciente", name: "paciente" },
        {
            title: "Fecha Inicio Periodo",
            name: "fechaIniPeriodo",
            render: row => formatDate(row.fechaIniPeriodo)
        },
        {
            title: "Fecha Fin Periodo",
            name: "fechaFinPeriodo",
            render: row => formatDate(row.fechaFinPeriodo)
        },
        { title: "Días", name: "dias" },
        {
            title: "Total Turno",
            name: "total_turno",
            render: row => `$${formatMoney(row.total_turno)}`
        },
        {
            title: "Total Movilización",
            name: "total_movilizacion",
            render: row => `$${formatMoney(row.total_movilizacion)}`
        },
        {
            title: "Total Colación",
            name: "total_colacion",
            render: row => `$${formatMoney(row.total_colacion)}`
        },
        {
            title: "Total",
            name: "total_dias",
            render: row => `$${formatMoney(row.total)}`
        }
    ];

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Cobranza</h3>
                    <div className="row g-3 align-items-end">
                        <div className="col-md-6">
                            <label className="form-label">Mes</label>
                            <input
                                type="month"
                                className="form-control"
                                value={fecha}
                                onChange={e => setFecha(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <button
                                className="btn btn-primary w-100"
                                onClick={buscarCobranza}
                                disabled={!fecha}
                            >
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="mt-3">
                        <GdTable
                            columns={columns}
                            data={resultados}
                            stickyHeader={true}
                            height={600}
                            headerHeight={50}
                            showCsvExport={true}
                            initialSort={[0, "asc"]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cobranza;
